import { render, staticRenderFns } from "./ProductPascabayar.vue?vue&type=template&id=e72ade2e"
import script from "./ProductPascabayar.vue?vue&type=script&lang=js"
export * from "./ProductPascabayar.vue?vue&type=script&lang=js"
import style0 from "./ProductPascabayar.vue?vue&type=style&index=0&id=e72ade2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports